import {
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { LazyLoadEvent } from "primeng/api";
import { Subscription } from "rxjs";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../interfaces/event.model";
import { BroadcastService } from "../../services/broadcast.service";
import { WebsocketService } from "../../../websocket.service";

@Component({
	selector: "app-datatable",
	templateUrl: "./datatable.component.html",
	styleUrls: ["./datatable.component.scss"],
})
export class DatatableComponent implements OnInit, OnDestroy {
	@Input() options: any;
	UserSocket = null;

	data: any;
	dataTable = {
		rowsPerPage: 15,
		first: 0,
		rows: 15,
	};
	loading: boolean;
	tableId;

	tableService$: Subscription;
	bc$;

	constructor(
		private broadcast: BroadcastService,
		private changeDetectorRef: ChangeDetectorRef,
		private wsService: WebsocketService,
	) {
		this.bc$ = this.bc$ = this.broadcast.on(
			EventSubscriptionType.TYPE,
			EventType.DATATABLE,
			(event: EventModel) => {
				switch (event.name) {
					case "datatable-filter":
						this.loadData({ first: 10, rows: 10 });
						break;
					case "datatable-reload":
						this.loadData({
							first: this.dataTable.first,
							rows: this.dataTable.rows,
						});
						break;

					// case 'datatable-show-childTable': this.expandRow(event.data); break;
				}
			},
		);
	}

	ngOnInit(): void {
		this.loading = true;
		// this.UserSocket = this.options.config.usersSocket
		this.dataTable.rowsPerPage = this.options.config.rowsPerPage || 15;
	}

	ngOnDestroy(): void {
		if (this.bc$) {
			this.bc$();
		}
		if (this.tableService$) {
			this.tableService$.unsubscribe();
		}
	}

	getIsAlive(item: any): void {}

	async loadData(event: LazyLoadEvent): Promise<void> {
		this.loading = true;

		// in a real application, make a remote request to load data using state metadata from event
		// event.first = First row offset
		// event.rows = Number of rows per page
		// event.sortField = Field name to sort with
		// event.sortOrder = Sort order as number, 1 for asc and -1 for dec
		// filters: FilterMetadata object having field as key and filter value, filter matchMode as value
		const page = (event.first + event.rows) / event.rows;
		const apiOptions = this.options.config.params;

		const baseService = this.options.config.base;
		const baseFunction = this.options.config.api;


		this.tableService$ = baseService[`${baseFunction}`](
			page,
			apiOptions,
		).subscribe(async (response) => {
			if (this.options.config?.hasCustomProcessData) {
				this.data = await this.options.config.processValues(response);
			} else {
				this.data = response;
			}
			this.loading = false;
			this.changeDetectorRef.markForCheck();
		});
	}

	pageChange(event): void {
		this.dataTable.first = event.first;
		this.dataTable.rows = event.rows;
	}

	triggerEvent(action, item): void {
		this.broadcast.fire({
			name: action.event,
			type: EventType.MODAL,
			data: {
				action,
				item,
			},
		});
	}

	async searchData(value): Promise<void> {
		if (!value) this.options.config.params.key = "";
		else {
			this.options.config.params.key = value;
		}
		this.loadData({ first: 0, rows: 15 });
	}

	/* Retorna la clase dependiendo del estado del registro */
	getRowClass(rowData: any): string {
		if (rowData.active === 1 || rowData.active === "Activo") {
			return "row-active";
		}
		return "row-inactive";
	}
}
